



const tab1 = (props: { form: any })=>{

    return(
        <>
        </>
    )
}

export default  tab1;